import { BaseSyntheticEvent, FC, useEffect, useState } from 'react'
import { PageTitle } from '../../../../../_metronic/layout/core'
import { Button } from '../../../../components/Button/Button'
import Swal from 'sweetalert2'
import { POST, PUT, GET } from '../../../../services/api'
import { Input } from '../../../../components/Input/Input'
import { Loading } from '../../../../components/Loading/Loading'
import { useNavigate, useParams } from 'react-router-dom'
import moment from 'moment-timezone'
import { i18n } from '../../../../translate/i18n'
import uuid from 'react-uuid'
import { BreadCrumbs } from '../../../../components/BreadCrumbs/breadCrumbrs'
import { ProductFilter } from '../../../../components/CatalogFilterProducts/FilterModal'
import ProductSearchCard from '../../../../components/CatalogosTable/CatalogTableAdd'
import CatalogProductsTable from '../../../../components/CatalogosTable/CatalogTableItens'
import { TypeListProduct, FilterOption, ProductFilterRequestDTO, FilterState, MetaType, Seller, OrderType } from './type'
import { generateLinkCatalog, mapSellerToSelectOptions } from './aux-catalog'

const DuplicarCatalogosContent: FC = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const [loading, setLoading] = useState(false)
  const [loadingComp, setLoadingComp] = useState(false)
  const [name, setName] = useState('')
  const [order, setOrder] = useState('0')

  const [searchproduct, setSearchProduct] = useState('')
  const [listsearchproducts, setListSearchProducts] = useState<TypeListProduct[]>([])
  const [listProducts, setListProducts] = useState<TypeListProduct[]>([])

  const [startDate, setStartDate] = useState('')
  const [startTimeDate, setStartTimeDate] = useState('')
  const [finalDate, setFinalDate] = useState('')
  const [finalTimeDate, setFinalTimeDate] = useState('')

  const [image, setImage] = useState<File | null>(null)
  const [firstStateImage, setFirstStateImage] = useState<File | null>(null)

  /*Novos Campos */
  const [linkCatalog, setLinkCatalog] = useState<string>('')
  const [sellerId, setSellerId] = useState<number>(0)
  const [sellerCatalog, setSellerCatalog] = useState<boolean>(false)
  const [sellers, setSeller] = useState<Seller[]>([])
  const [isExclusive, setIsExclusive] = useState<boolean>(false)
  const [meta, setMeta] = useState<MetaType | undefined>(undefined)

  // Novos estados para os filtros
  const [showFilters, setShowFilters] = useState(false)
  const [categories, setCategories] = useState<FilterOption[]>([])
  const [groups, setGroups] = useState<FilterOption[]>([])
  const [activeFilters, setActiveFilters] = useState<FilterState>({
    categories: [],
    status: '',
    groups: [],
  })

  const [listProductsSelected, setListProductsSelected] = useState<number>(0)
  const [listProductsCatalogSelected, setListProductsCatalogSelected] = useState<number>(0)

  const loadCategories = async () => {
    try {
      const response = await POST('/classification/filter', { status: true })
      if (response.success) {
        setCategories(
          response.data.map((cat: any) => ({
            label: cat.name,
            value: cat.id,
          }))
        )
      }
    } catch (error) {
      console.error('Erro ao carregar categorias:', error)
    }
  }

  const loadGroups = async () => {
    try {
      const response = await GET('/customer_groups')
      if (response.success) {
        setGroups(
          response.data.map((group: any) => ({
            label: group.name,
            value: group.id,
          }))
        )
      }
    } catch (error) {
      console.error('Erro ao carregar grupos:', error)
    }
  }

  const handleApplyFilters = (filters: FilterState) => {
    setActiveFilters(filters)
    searchProductWithFilters(filters)
  }

  const handleClearFilters = () => {
    setActiveFilters({
      categories: [],
      status: '',
      groups: [],
    })
    if (searchproduct) {
      searchProduct()
    }
  }

  const transformFiltersToDTO = (
    filters: FilterState,
    productName: string
  ): ProductFilterRequestDTO => {
    const dto: ProductFilterRequestDTO = {
      name: productName,
      categories: filters.categories.length > 0 ? filters.categories : undefined,
      groups: filters.groups.length > 0 ? filters.groups : undefined,
    }

    switch (filters.status) {
      case 'active':
        dto.status = true
        break
      case 'inactive':
        dto.status = false
        break
      case 'in_stock':
        dto.status = true // Assuming active products
        dto.isInventoryGreaterThan = 0
        break
      case 'out_of_stock':
        dto.status = true // Assuming active products
        dto.isInventoryLessThan = 1
        break
      default:
        // If no status filter, don't include status in DTO
        break
    }

    return dto
  }

  const searchProductWithFilters = async (filters: FilterState) => {
    try {
      setLoadingComp(true)
      const filterDTO = transformFiltersToDTO(filters, searchproduct)

      const res = await POST('/product/filter-catalogs', filterDTO)

      setListSearchProducts(res.data)
      setMeta(res.meta)
      setLoadingComp(false)
    } catch (error) {
      setLoadingComp(false)
      console.error('Erro ao filtrar produtos:', error)
    }
  }

  const hasActiveFilters =
    activeFilters.categories.length > 0 ||
    activeFilters.status !== '' ||
    activeFilters.groups.length > 0

  const searchProduct = async (
    take: number = 200,
    page: number = 1,
    search: string = '',
    order: OrderType = { field: 'name', type: 'ASC' }
  ) => {
    try {
      if (!searchproduct.trim() && !search.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção',
          text: 'Informe o nome do produto, antes de pesquisa!',
        })
        return
      }

      let res
      if (!search.trim()) {
        setLoadingComp(true)
        const filterDTO = transformFiltersToDTO(activeFilters, searchproduct)
        res = await POST(`/product/filter-catalogs?order=ASC&page=${page}&take=${take}`, filterDTO)
      } else {
        setLoadingComp(true)
        if (listsearchproducts.length > 0) {
          const resFilter = listsearchproducts.filter((product: any) => {
            return product.name.toLowerCase().includes(search.toLowerCase())
          })

          res = {
            data: resFilter,
            meta: {
              hasNextPage: false,
              hasPreviousPage: false,
              itemCount: resFilter.length,
              page: 1,
              pageCount: 1,
              take: 200,
            },
          }
        } else {
          const filterDTO: ProductFilterRequestDTO = {
            isInventoryGreaterThan: 1,
          }
          res = await POST(
            `/product/filter-catalogs?order=ASC&page=${page}&take=${take}&search=${search}`,
            filterDTO
          )
        }
      }

      setListSearchProducts(res.data)
      setMeta(res.meta)
      setLoadingComp(false)
    } catch (e) {
      setLoadingComp(false)
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Um erro ocorreu ao filtrar os produto, verifique os nome informado!',
      })
    }
  }

  const addList = (id: any) => {
    const newList = [...listProducts]
    const alreadyExists = newList.some((product) => product.id === id)

    if (!alreadyExists) {
      const selected = listsearchproducts.find((product) => product.id === id)
      if (selected) {
        newList.push({
          ...selected,
          selected: false, // Adiciona o campo selected com valor false
        })
        setListProducts(newList)
      }
    }
  }

  const delList = (id: any) => {
    const newList = listProducts.filter((row) => row.id !== id)
    setListProducts(newList)
  }

  async function loadSellers() {
    try {
      const resSeller = await POST('/users/filter', {
        type: 'seller',
        status: true,
      })

      if (!resSeller || !resSeller.success) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção',
          text: 'Não foi possivel carregar os vendedores!',
        })
        return
      }

      resSeller.data.unshift({ name: 'Escolha um vendedor', id: 0, cpf: '0', sellerCode: '0', numberPhone: '0' })

      setSeller(resSeller.data)
    } catch (error) { }
  }

  const getCatalog = async () => {
    try {
      const resCatalog = (await GET(`/catalog/${id}/admin`)).data[0]

      const newCatalogs = resCatalog.catalogItems.map((row: any) => {
        return {
          id: row.productId,
          name: row.product.name,
          price: '',
          image: '',
          sellerId: resCatalog.sellerId,
          allowDiscount: row.allowDiscount,
          sellerCatalog: resCatalog.sellerCatalog,
          selected: false,
        }
      })

      setListProducts(newCatalogs)
      setName(resCatalog.catalog + ' - Cópia')
      setOrder(resCatalog.order)
      setLinkCatalog(resCatalog.linkCatalog)
      setSellerCatalog(resCatalog.sellerCatalog)
      setIsExclusive(resCatalog.isExclusive)
      setSellerId(resCatalog.sellerId)

      // Converter de UTC para o fuso horário de São Paulo para exibição
      const saoPauloTimezone = 'America/Sao_Paulo'

      // Converter dateStart de UTC para São Paulo
      const startDateSP = moment.utc(resCatalog.dateStart).tz(saoPauloTimezone)
      setStartDate(startDateSP.format('YYYY-MM-DD'))
      setStartTimeDate(startDateSP.format('HH:mm:ss'))

      // Converter dateEnd de UTC para São Paulo
      const endDateSP = moment.utc(resCatalog.dateEnd).tz(saoPauloTimezone)
      setFinalDate(endDateSP.format('YYYY-MM-DD'))
      setFinalTimeDate(endDateSP.format('HH:mm:ss'))

      let imgCatalog = null
      if (resCatalog.imgCatalog) {
        imgCatalog =
          resCatalog.imgCatalog.substring(0, 4) === 'http'
            ? resCatalog.imgCatalog
            : process.env.REACT_APP_AWS_S3_URL + resCatalog.imgCatalog
      }
      setImage(imgCatalog)
      setFirstStateImage(imgCatalog)
      setLoading(false)
    } catch (e) {
      setLoadingComp(false)
      console.log(e)
    }
  }

  const create = async () => {
    try {
      if (
        !name ||
        !startDate ||
        !finalDate ||
        !finalTimeDate ||
        !startTimeDate ||
        (sellerCatalog && !sellerId)
      ) {
        Swal.fire({
          icon: 'error',
          title: 'Campos faltantes',
          text: 'Verifique se preencheu todos os campos!',
        })
        return
      }
      setLoading(true)
      let imageRes = {
        success: false,
        image: '',
      }

      const catalogItem = listProducts.map((row) => {
        return {
          productId: row.id,
          sellerId: row.sellerId,
          allowDiscount: sellerCatalog && row.allowDiscount,
          sellerCatalog: sellerCatalog,
          status: true,
        }
      })

      // Validação das datas
      const startDateTime = moment(`${startDate} ${startTimeDate}`, 'YYYY-MM-DD HH:mm:ss', true)
      const endDateTime = moment(`${finalDate} ${finalTimeDate}`, 'YYYY-MM-DD HH:mm:ss', true)

      if (!startDateTime.isValid() || !endDateTime.isValid()) {
        Swal.fire({
          icon: 'error',
          title: 'Data inválida',
          text: 'Verifique se as datas e horários estão corretos!',
        })
        setLoading(false)
        return
      }

      if (endDateTime.isSameOrBefore(startDateTime)) {
        Swal.fire({
          icon: 'error',
          title: 'Data final inválida',
          text: 'A data/hora final deve ser posterior à data/hora inicial!',
        })
        setLoading(false)
        return
      }

      const resCatalog = await POST('/catalog', {
        catalog: name,
        dateStart: moment(`${startDate} ${startTimeDate}`, 'YYYY-MM-DD HH:mm:ss')
          .utc()
          .toISOString(),
        dateEnd: moment(`${finalDate} ${finalTimeDate}`, 'YYYY-MM-DD HH:mm:ss').utc().toISOString(),
        order: order,
        sellerCatalog: sellerCatalog,
        isExclusive: sellerCatalog && isExclusive,
        sellerId: sellerCatalog ? sellerId : null,
        linkCatalog,
        catalogItem: catalogItem,
        imgCatalog: '',
      })

      if (image && resCatalog.success && image !== firstStateImage) {
        const formData = new FormData()
        formData.append('file', image)
        formData.append('nameImage', `catalog-${uuid()}.jpg`)
        imageRes = await POST('/upload-images/upload-one', formData)
        if (imageRes.success) {
          await PUT(`/catalog/${resCatalog.dados.id}`, {
            fotoCatalog: imageRes.image,
          })
        }
      } else {
        if (image && resCatalog.success) {
          await PUT(`/catalog/${resCatalog.dados.id}`, {
            fotoCatalog: image,
          })
        }
      }

      setLoading(false)

      if (resCatalog.success === true) {
        Swal.fire({
          icon: 'success',
          title: 'Catálogo duplicado',
          text: 'Duplicação realizada com sucesso!',
        }).then(() => navigate(`/catalog`))
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao duplicar o catálogo!',
        })
      }
    } catch (e) {
      setLoadingComp(false)
      console.log(e)
    }
  }

  async function loadAll() {
    try {
      setLoading(true)
      await Promise.all([loadSellers(), getCatalog(), loadCategories(), loadGroups()])
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadAll()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

   function changeCatalogLink() {
    if (sellerCatalog) {
      setLinkCatalog(generateLinkCatalog(sellerId, sellers) || '')
    }
  }

  useEffect(() => {
    if (sellerId) changeCatalogLink()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sellerId])

  const switchAllowDiscount = async (Id: number, status: boolean) => {
    try {
      const newProducts = listProducts.map((product) => {
        if (product.id === Id.toString()) {
          product.allowDiscount = !status
        }
        return product
      })
      setListProducts(newProducts)
    } catch (e) {
      console.log(e)
    }
  }

  // const switchSelectedToCatalog = async (Id: number, status: boolean) => {
  //   try {
  //     const newProducts = listsearchproducts.map((el) => {
  //       if (el.id.toString() === Id.toString()) {
  //         el.selected = !el.selected
  //       }
  //       return el
  //     })
  //     const qtrSelected = newProducts.filter((el) => el.selected).length
  //     setListProductsSelected(qtrSelected)
  //   } catch (e) {
  //     console.log(e)
  //   }
  // }

  // const switchSelectedInCatalog = async (Id: number, status: boolean) => {
  //   try {
  //     const newProducts = listProducts.map((el) => {
  //       if (el.id.toString() === Id.toString()) {
  //         el.selected = !el.selected
  //       }
  //       return el
  //     })
  //     setListProductsCatalogSelected(newProducts.filter((el) => el.selected).length)
  //   } catch (e) {
  //     console.log(e)
  //   }
  // }

  function addMultipleList() {
    const selectedProducts = listsearchproducts.filter((el) => el.selected)

    const currentProducts = [...listProducts]
    const productsToAdd = selectedProducts.filter(
      (product) => !currentProducts.some((existing) => existing.id === product.id)
    )

    if (productsToAdd.length > 0) {
      setListProducts([
        ...currentProducts,
        ...productsToAdd.map((product) => ({
          ...product,
          selected: false,
        })),
      ])
    }
    const updatedSearchProducts = listsearchproducts.map((product) => ({
      ...product,
      selected: false,
    }))
    setListSearchProducts(updatedSearchProducts)
    setListProductsSelected(0)
  }

  function removeMultipleList() {
    const selectedProducts = listProducts.filter((el) => el.selected)

    const currentProducts = [...listProducts]
    const productsToKeep = currentProducts.filter(
      (product) => !selectedProducts.some((selected) => selected.id === product.id)
    )

    if (selectedProducts.length > 0) {
      setListProducts(productsToKeep)
      setListProductsCatalogSelected(0)
    }
  }

  function activeMultipleDiscount() {
    const selectedProducts = listProducts.filter((el) => el.selected)

    if (selectedProducts.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Atenção',
        text: 'Nenhum produto selecionado para ativar desconto!',
      })
      return
    }

    const updatedProducts = listProducts.map((product) => {
      if (selectedProducts.some((el) => el.id === product.id)) {
        product.allowDiscount = true
        product.selected = false
      }
      return product
    })
    setListProductsCatalogSelected(0)
    setListProducts(updatedProducts)
  }

  const desactiveMultipleDiscount = () => {
    const selectedProducts = listProducts.filter((el) => el.selected)

    if (selectedProducts.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Atenção',
        text: 'Nenhum produto selecionado para remover desconto!',
      })
      return
    }

    const updatedProducts = listProducts.map((product) => {
      if (selectedProducts.some((el) => el.id === product.id)) {
        product.allowDiscount = false
        product.selected = false
      }
      return product
    })
    setListProductsCatalogSelected(0)
    setListProducts(updatedProducts)
  }

  function onSelectAllProductsInCatalog(all: boolean, id: number, value: boolean) {
    try {
      const newListProducts = listProducts.map((row: any) => {
        if (all) {
          row.selected = value
        }
        if (!all && row.id === id) {
          row.selected = !row.selected
        }
        return row
      })

      setListProductsCatalogSelected(newListProducts.filter((item) => item.selected).length)
    } catch (error) {
      console.log(error)
      return
    }
  }

  function onSelectAllProductsFiltered(all: boolean, id: number, value: boolean) {
    try {
      const newListProducts = listsearchproducts.map((row: any) => {
        if (all) {
          row.selected = value
        }
        if (!all && row.id === id) {
          row.selected = !row.selected
        }
        return row
      })

      setListProductsSelected(newListProducts.filter((item) => item.selected).length)
    } catch (error) {
      console.log(error)
      return
    }
  }

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
          <div className='row g-5 gx-xxl-12'>
            {/* Seção 1: Informações Básicas do Catálogo */}
            <div className='col-12'>
              <div className='card card-xxl-stretch mb-5'>
                <div className='card-header py-5'>
                  <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bolder fs-3 mb-1'>
                      {i18n.t(`smart_order.catalogs`)}
                    </span>
                    <BreadCrumbs />
                    <span className='text-muted mt-1 fw-bold fs-7'>
                      {i18n.t(`general.save_changes_duplicate`)}
                    </span>
                  </h3>
                </div>
                <div className='card-body'>
                  <div className='d-flex flex-row flex-wrap gap-10'>
                    <div>
                      <Input
                        inputAttr={{
                          type: 'image',
                        }}
                        label={i18n.t(`smart_order.catalog_image`)}
                        value={image}
                        change={(value: BaseSyntheticEvent) =>
                          setImage(value ? value.target.files[0] : null)
                        }
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div className='row'>
                        <div className='col-md-6'>
                          <Input
                            inputAttr={{
                              type: 'default',
                            }}
                            placeholder={i18n.t(`smart_order.name`)}
                            label={i18n.t(`smart_order.name`)}
                            value={name}
                            change={(value: string) => setName(value)}
                          />
                        </div>
                        <div className='col-md-2'>
                          <Input
                            inputAttr={{
                              type: 'number',
                            }}
                            placeholder={i18n.t(`smart_order.order`)}
                            label={i18n.t(`smart_order.order`)}
                            value={order}
                            change={(value: string) => setOrder(value)}
                          />
                        </div>
                        <div className='col-md-4'>{/* Espaço para manter o layout */}</div>
                      </div>
                      <div className='row'>
                        <div className='col-md-4'>
                          <Input
                            inputAttr={{ type: 'date' }}
                            label={i18n.t(`smart_order.date_start`)}
                            value={startDate}
                            change={setStartDate}
                            maxLength={finalDate}
                          />
                        </div>
                        <div className='col-md-4'>
                          <Input
                            inputAttr={{ type: 'time' }}
                            placeholder='hh:mm:ss'
                            label={i18n.t(`smart_order.initial_hour`)}
                            value={startTimeDate}
                            change={setStartTimeDate}
                          />
                        </div>
                        <div className='col-md-4'>{/* Espaço para manter o layout */}</div>
                      </div>
                      <div className='row'>
                        <div className='col-md-4'>
                          <Input
                            inputAttr={{ type: 'date' }}
                            label={i18n.t(`smart_order.date_end`)}
                            value={finalDate}
                            change={setFinalDate}
                            minLength={startDate}
                          />
                        </div>
                        <div className='col-md-4'>
                          <Input
                            inputAttr={{ type: 'time' }}
                            placeholder='hh:mm:ss'
                            label={i18n.t(`smart_order.final_hour`)}
                            value={finalTimeDate}
                            change={setFinalTimeDate}
                          />
                        </div>
                        <div className='col-md-4'>{/* Espaço para manter o layout */}</div>
                      </div>
                      <div className='row'>
                        <div className='col-12 mt-6'>
                          <Input
                            inputAttr={{ type: 'checkbox' }}
                            label={'Catálogo Vendedor'}
                            value={sellerCatalog}
                            change={(value: boolean) => setSellerCatalog(value)}
                            checked={sellerCatalog}
                          />

                          {sellerCatalog && (
                            <div className='d-flex gap-4 align-items-center mt-3'>
                              <div style={{ minWidth: '200px' }}>
                                <Input
                                  inputAttr={{ type: 'select' }}
                                  label={'Selecione o Vendedor'}
                                  value={sellerId}
                                   options={mapSellerToSelectOptions(sellers)}
                                  change={(value: string) => setSellerId(parseInt(value))}
                                />
                              </div>
                              {sellerId !== 0 && sellerId > 0 && (
                                <div
                                  className='d-flex align-items-center'
                                  style={{ marginTop: '2rem' }}
                                >
                                  <Input
                                    inputAttr={{ type: 'checkbox' }}
                                    label={'Catálogo Exclusivo'}
                                    value={isExclusive}
                                    change={(value: boolean) => setIsExclusive(value)}
                                    checked={isExclusive}
                                  />
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Seção 2: Gestão de Produtos */}
            <div className='same-height-container'>
              <ProductSearchCard
                // Props principais
                searchValue={searchproduct}
                onSearchChange={setSearchProduct}
                onSearch={() => searchProduct()}
                searchResults={listsearchproducts}
                loading={loadingComp}
                selectedCount={listProductsSelected}
                // Props de filtros
                hasActiveFilters={hasActiveFilters}
                activeFilters={activeFilters}
                onShowFilters={() => setShowFilters(true)}
                onClearFilters={handleClearFilters}
                // Props da tabela
                onSelectAll={onSelectAllProductsFiltered}
                onAddItem={addList}
                meta={meta}
                onTableDataChange={searchProduct}
                // Props de customização
                title='Seus Produtos'
                titleIcon='fas fa-search'
                searchPlaceholder={i18n.t(`smart_order.search_products`)}
                emptyMessage='Pesquise por produtos para adicionar ao catálogo'
                noResultsMessage='Nenhum produto encontrado'
                // Props opcionais
                showSelectedButton={true}
                onSelectedAction={addMultipleList}
                tableHeaders={[
                  { key: 'Código', value: 'code', type: 'default' },
                  { key: i18n.t(`smart_order.prod`), value: 'name', type: 'default' },
                  { key: i18n.t(`general.actions`), value: 'acoes', type: '', noOrder: true },
                ]}
                tableOptions={[
                  {
                    icon: 'fas fa-plus',
                    title: 'adicionar',
                    color: 'success',
                    action: (item) => addList(item.id),
                  },
                ]}
                // Props de layout
                cardClassName='card same-height-column mb-5'
                maxTableHeight='400px'
              />

              <CatalogProductsTable
                // Props principais
                products={listProducts}
                selectedCount={listProductsCatalogSelected}
                showSellerOptions={sellerCatalog}
                // Props de ações
                onSelectAll={onSelectAllProductsInCatalog}
                onRemoveProduct={delList}
                onToggleDiscount={switchAllowDiscount}
                // Props de ações em massa
                onAddMultipleDiscount={activeMultipleDiscount}
                onRemoveMultipleDiscount={desactiveMultipleDiscount}
                onRemoveMultipleProducts={removeMultipleList}
                // Props de customização
                title='Produtos no Catálogo'
                titleIcon='fas fa-clipboard'
                emptyMessage='Nenhum produto adicionado ao catálogo'
                emptySubMessage='Use a pesquisa ao lado para encontrar e adicionar produtos'
                tableColor='success'
                maxTableHeight='400px'
                // Headers customizados
                customHeaders={[
                  { key: 'Código', value: 'code', type: 'default' },
                  { key: i18n.t(`smart_order.prod`), value: 'name', type: 'default' },
                  {
                    key: 'Permitir Desconto',
                    value: 'allowDiscount',
                    type: 'check',
                    action: (item: any) => switchAllowDiscount(item.id, item.allowDiscount),
                    show: sellerCatalog,
                  },
                  { key: i18n.t(`general.actions`), value: 'acoes', type: '', noOrder: true },
                ]}
                // Opções customizadas da tabela
                customOptions={[
                  {
                    icon: 'fas fa-trash',
                    action: (item: any) => delList(item.id),
                    title: 'remover',
                    color: 'danger',
                  },
                ]}
                // Opções do catálogo
                catalogOptions={[
                  {
                    name: 'Permitir Desconto',
                    icon: 'bi-plus',
                    action: () => activeMultipleDiscount(),
                    show: sellerCatalog,
                  },
                  {
                    name: 'Remover Permissão de Desconto',
                    icon: 'bi-dash',
                    action: () => desactiveMultipleDiscount(),
                    show: sellerCatalog,
                  },
                  {
                    name: 'Remover Produto(s)',
                    icon: 'bi-trash',
                    action: () => removeMultipleList(),
                  },
                ]}
                // Props de layout
                cardClassName='card same-height-column mb-5'
                showCatalogOptions={true}
              />
            </div>

            {/* Seção 3: Ações */}
            <div className='col-12'>
              <div className='card card-xxl-stretch'>
                <div className='card-body'>
                  <div className='d-flex justify-content-between align-items-center'>
                    <Button
                      text={i18n.t(`buttons.back`)}
                      color='info'
                      size='small'
                      horizontalPadding={6}
                      btnAttr={{
                        type: 'button',
                      }}
                      click={() => navigate(-1)}
                      btnClass='fw-bolder'
                    />

                    <div className='d-flex gap-3'>
                      {/* Resumo rápido */}
                      <Button
                        text={i18n.t(`buttons.save`)}
                        color='primary'
                        size='small'
                        horizontalPadding={6}
                        btnAttr={{
                          type: 'button',
                        }}
                        click={() => create()}
                        btnClass='fw-bolder'
                        disabled={
                          !name || !startDate || !finalDate || !finalTimeDate || !startTimeDate
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

      {/* Modal de Filtros */}
      <ProductFilter
        isOpen={showFilters}
        activeFilters={activeFilters}
        setActiveFilters={setActiveFilters}
        onClose={() => setShowFilters(false)}
        onApplyFilters={handleApplyFilters}
        onClearFilters={handleClearFilters}
        categories={categories}
        groups={groups}
        loading={loadingComp}
      />
    </>
  )
}

const DuplicarCatalogos: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          { title: 'Dashboard', path: 'dashboard', isActive: true },
          { title: i18n.t(`smart_order.catalogs`), path: 'catalog', isActive: true },
          { title: i18n.t(`general.edit`), path: 'catalog/criar', isActive: true },
        ]}
      >
        {`${i18n.t(`general.edit`)} ${i18n.t(`smart_order.catalog`)}`}
      </PageTitle>
      <DuplicarCatalogosContent />
    </>
  )
}

export { DuplicarCatalogos }
